import { render, staticRenderFns } from "./GebruikersBase.vue?vue&type=template&id=8a037b48&scoped=true&"
import script from "./GebruikersBase.vue?vue&type=script&lang=js&"
export * from "./GebruikersBase.vue?vue&type=script&lang=js&"
import style0 from "./GebruikersBase.vue?vue&type=style&index=0&id=8a037b48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a037b48",
  null
  
)

export default component.exports